import { createAsyncThunk } from '@reduxjs/toolkit';

import { buildSpendInsightsBody } from '../lib/buildSpendInsightsBody';

import type {
    SpendCategoryRowDto,
    SpendInsightsOrderBy,
    SpendInsightsRequestParams,
} from '../types/ReportSpendSummarySchema';
import type { ThunkConfig } from 'app/providers/StoreProvider/config/types';

export interface FetchSpendByCategoryParams extends SpendInsightsRequestParams {
    orderBy?: SpendInsightsOrderBy;
}

export const fetchSpendByCategory = createAsyncThunk<
    SpendCategoryRowDto[],
    FetchSpendByCategoryParams,
    ThunkConfig<string>
>('reportSpendSummary/fetchSpendByCategory', async (params, thunkApi) => {
    const { extra, rejectWithValue } = thunkApi;
    try {
        const { orderBy = '-total_spend', ...filters } = params;
        const response = await extra.api.post<{
            items: SpendCategoryRowDto[];
        }>(
            '/v1/reports/spend-insights/by-category',
            buildSpendInsightsBody(filters, { orderBy }),
        );
        return response.data.items ?? [];
    } catch {
        return rejectWithValue('error');
    }
});
